module.exports = __webpack_public_path__ + "img/dashboard-inactive.4534e41.png";